<template>
  <div class="row">
			<reviewed-user-information
				:reviewedUser="review.user_name"
				:index="index"
			/>
    <div class="col-2 col-lg-2 p-0 m-0">
      <a
        class="rating-action"
        :class="activeLike?'active':''"
        href
        @click.prevent="helpFul(true,review.review_id)"
								:data-test="'reviewFooterHelpfullLink'+index"
								:id="'reviewFooterHelpfullLink'+index"
      >
        <div class="icon icon--ei-like icon--s like">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
												:data-test="'reviewFooterHelpfullSvg'+index"
												:id="'reviewFooterHelpfullSvg'+index"
          >
            <path d="M40 23.2c0-2.1-1.7-3.2-4-3.2h-6.7c.5-1.8.7-3.5.7-5 0-5.8-1.6-7-3-7-.9 0-1.6.1-2.5.6-.3.2-.4.4-.5.7l-1 5.4c-1.1 2.8-3.8 5.3-6 7V36c.8 0 1.6.4 2.6.9 1.1.5 2.2 1.1 3.4 1.1h9.5c2 0 3.5-1.6 3.5-3 0-.3 0-.5-.1-.7 1.2-.5 2.1-1.5 2.1-2.8 0-.6-.1-1.1-.3-1.6.8-.5 1.5-1.4 1.5-2.4 0-.6-.3-1.2-.6-1.7.8-.6 1.4-1.6 1.4-2.6zm-2.1 0c0 1.3-1.3 1.4-1.5 2-.2.7.8.9.8 2.1 0 1.2-1.5 1.2-1.7 1.9-.2.8.5 1 .5 2.2v.2c-.2 1-1.7 1.1-2 1.5-.3.5 0 .7 0 1.8 0 .6-.7 1-1.5 1H23c-.8 0-1.6-.4-2.6-.9-.8-.4-1.6-.8-2.4-1V23.5c2.5-1.9 5.7-4.7 6.9-8.2v-.2l.9-5c.4-.1.7-.1 1.2-.1.2 0 1 1.2 1 5 0 1.5-.3 3.1-.8 5H27c-.6 0-1 .4-1 1s.4 1 1 1h9c1 0 1.9.5 1.9 1.2z" />
            <path d="M16 38h-6c-1.1 0-2-.9-2-2V22c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zm-6-16v14h6V22h-6z" />
          </svg>
        </div>
        <span
          class="count"
          :id="'review-helpfullcount-'+index"
										:data-test="'reviewFooterHelpfullCount'+index"
        >
          {{review.helpFullCount}}
        </span>
        <span :id="'review-helpfull-'+index"
														:data-test="'reviewFooterHelpfullSpan'+index"></span>
      </a>
    </div>
    <div class="col-2 col-lg-2 p-0 m-0">
      <a
        class="rating-action"
        :class="activeDislike?'active':''"
        href
        @click.prevent="helpFul(false,review.review_id)"
								:data-test="'reviewFooterNotHelpfullLink'+index"
								:id="'reviewFooterNotHelpfullLink'+index"
      >
        <div class="icon icon--ei-like icon--s dislike">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
												:data-test="'reviewFooterNotHelpfullSvg'+index"
												:id="'reviewFooterNotHelpfullSvg'+index"

          >
            <path d="M40 23.2c0-2.1-1.7-3.2-4-3.2h-6.7c.5-1.8.7-3.5.7-5 0-5.8-1.6-7-3-7-.9 0-1.6.1-2.5.6-.3.2-.4.4-.5.7l-1 5.4c-1.1 2.8-3.8 5.3-6 7V36c.8 0 1.6.4 2.6.9 1.1.5 2.2 1.1 3.4 1.1h9.5c2 0 3.5-1.6 3.5-3 0-.3 0-.5-.1-.7 1.2-.5 2.1-1.5 2.1-2.8 0-.6-.1-1.1-.3-1.6.8-.5 1.5-1.4 1.5-2.4 0-.6-.3-1.2-.6-1.7.8-.6 1.4-1.6 1.4-2.6zm-2.1 0c0 1.3-1.3 1.4-1.5 2-.2.7.8.9.8 2.1 0 1.2-1.5 1.2-1.7 1.9-.2.8.5 1 .5 2.2v.2c-.2 1-1.7 1.1-2 1.5-.3.5 0 .7 0 1.8 0 .6-.7 1-1.5 1H23c-.8 0-1.6-.4-2.6-.9-.8-.4-1.6-.8-2.4-1V23.5c2.5-1.9 5.7-4.7 6.9-8.2v-.2l.9-5c.4-.1.7-.1 1.2-.1.2 0 1 1.2 1 5 0 1.5-.3 3.1-.8 5H27c-.6 0-1 .4-1 1s.4 1 1 1h9c1 0 1.9.5 1.9 1.2z" />
            <path d="M16 38h-6c-1.1 0-2-.9-2-2V22c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zm-6-16v14h6V22h-6z" />
          </svg>
        </div>
        <span
          class="count"
          :id="'review-nothelpfullcount-'+index"
										:data-test="'reviewFooterNotHelpfullCount'+index"
        >
          {{review.notHelpFullCount}}
        </span>
        <span :id="'review-nothelpfull-'+index"
														:data-test="'reviewFooterNotHelpfullSpan'+index"></span>
      </a>
    </div>
    <div class="col-1 p-0 m-0 text-center">
      <div
        class="report-abbuse-wrapper"
        :id="'report-abuse-'+index"
        :class="showReportAbuse===false?'open': ''"
      >
        <a
          href=""
          @click.prevent="reportAbuse()"
										:data-test="'reviewFooterReportAbuseLink'+index"
										:id="'reviewFooterReportAbuseLink'+index"
        >Report Abuse</a>
      </div>
      <a
        class="report-abuse-toggler d-block"
        @click.prevent="showReportAbuse === true?showReportAbuse = false: showReportAbuse = true"
								:data-test="'reviewFooterReportAbuseIconLink'+index"
								:id="'reviewFooterReportAbuseIconLink'+index"
      >
        <i class="fas fa-ellipsis-v"
											:data-test="'reviewFooterReportAbuseIcon'+index"
											:id="'reviewFooterReportAbuseIcon'+index"
											style="cursor: pointer"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { customerApi } from '../../../../../../services/ApiServices/customerApi'
import ReviewedUserInformation from './userInfo/ReviewedUserInformation'

export default {
	name: 'review-footer',
	props: {
		review: {},
		productId: null,
		index: {
			default: 0,
			type: Number
		}
	},
	data () {
		return {
			showReportAbuse: true,
			activeLike: false,
			activeDislike: false
		}
	},
	components: {
		ReviewedUserInformation
	},
	computed: {
		...mapGetters('user', ['isAuthenticated'])
	},
	methods: {
		helpFul (value, reviewId) {
			if (this.isAuthenticated) {
				if (value === true) {
					this.activeLike = true
					this.activeDislike = false
				} else {
					this.activeDislike = true
					this.activeLike = false
				}
				customerApi
					.commentReview(value, reviewId, this.productId)
					.then((res) => {
						this.$emit('commentReview', this.productId)
					})
					.catch((e) => {
					})
			} else {
				$(`#lightBox-review-${this.index}`).modal('hide')
				$(`#lightBoxWeb-review-${this.index}`).modal('hide')
				$('.modal-backdrop').remove()
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'previous'
					}
				})
			}
		},
		reportAbuse () {
			if (this.isAuthenticated) {
				customerApi.reportAbuse(this.review.review_id, true)
			} else {
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'previous'
					}
				})
			}
		}
	}
}
</script>
